import React, { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import PlayerChallenges from './challenges/challenges.component'
import PlayerHomeContent from './player-blocks/player-home-content.component'
import PlayerQuests from './player-blocks/quests.component'
import PlayerRewards from './rewards/rewards.component'
import './player-game-content.styles.scss'
import PlayerSideMenu from './side-menu.component'
import { useDispatch, useSelector } from 'react-redux'
import NewRewardModal from './player-blocks/modals/new-reward-modal.component'
import SubmitCode from './submit-code/submit-code.component'
import MyXpEarningsList from './player-blocks/components/status-elements/xp/my-xp-earnings-list.component'
import MyBadges from './player-blocks/components/status-elements/badges/my-badges.component'
import BadgeView from './player-blocks/components/status-elements/element-view.component'
import MyLevelsList from './player-blocks/components/status-elements/levels/my-levels-list.component'
import MyCurrencyEarningsList from './player-blocks/components/status-elements/currency/my-currency-earnings-list.component'
import MySecretCodesList from './player-blocks/components/status-elements/secret-codes/secret-codes-list.component'
import MyChallengesList from './player-blocks/components/status-elements/challenges/my-challenges-list.component'
import PlayerLeaderboardsContainer from './leaderboards/player-leaderboards-container.component'
import PlayerMarketLanding from './store/player-market-landing.component'
import ShoppingCart from './store/shopping-cart.component'
import InventoryLanding from './inventory/inventory-landing.component'
import DeclinedChallengeModal from './player-blocks/modals/approved-declined-modal.component'
import AcceptedItemModal from './player-blocks/modals/accepted-item-modal.component'
import GameActivity from './activity/player-activity.component'
import PurchaseView from '../SHARED/tranaction-view/transaction-view.component'
import TransactionView from '../SHARED/tranaction-view/transaction-view.component'
import useDocumentTitle from '@/utils/useDocumentTitle'
import MobilePlayerHomeContent from './player-blocks/mobile-player-home-content.component'
import ElementView from './player-blocks/components/status-elements/element-view.component'
import PlayerActivity from './activity/player-activity.component'

const PlayerGameContent = ({ 
    gameData, 
    playerData, 
    updatePlayerData,
    gameElements, 
    actionItems, 
    gameStats, 
    playerList, 
    gameActivity,
    teamMembers,
    myTeams,
    latestMessage
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const dispatch = useDispatch();
    const location = useLocation();

    // useDocumentTitle(gameData.gameName, gameData.icon);

    useEffect(() => {
        const playerGameContentDiv = document.querySelector('.game-content');
        if (playerGameContentDiv) {
            playerGameContentDiv.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [location])

    return (
        <div 
            className={`player-game-content ${screenSize}`}
            >
            {
                (playerData) &&
                <> 
                {
                    (
                        screenSize !== 'mobile' &&
                        screenSize !== 'tablet'
                    ) &&
                    <div className="side-menu-container">
                        <div className='g-card'>
                            <PlayerSideMenu 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements}
                            />
                        </div>
                    </div>
                }
                    <div className={`game-content ${screenSize}`} id='scroll-to-top'>
                    <Routes>
                        <Route path='' element={
                            (screenSize === 'mobile' || screenSize === 'tablet') ?
                            <MobilePlayerHomeContent
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                                actionItems={actionItems} 
                                playerList={playerList}
                                latestMessage={latestMessage}
                                teamMembers={teamMembers}
                            />
                            :
                            <PlayerHomeContent 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                                actionItems={actionItems} 
                                playerList={playerList}
                                latestMessage={latestMessage}
                                teamMembers={teamMembers}
                            />
                        }></Route>
                        <Route path='inventory/*' element={
                            <InventoryLanding
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                                gameActivity={gameActivity} 
                                gameStats={gameStats}
                                teamMembers={teamMembers}
                                myTeams={myTeams}
                            />
                        }></Route>
                        <Route path='rewards' element={
                            <PlayerRewards 
                                gameData={gameData} 
                                playerData={playerData} 
                                updatePlayerData={updatePlayerData}
                                gameElements={gameElements} 
                            />
                        }></Route>
                        <Route path='secretcode/*' element={
                            <SubmitCode 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route>
                        {/* <Route path='secretcode/:elementPath/*' element={
                            <ElementView 
                                gameData={gameData}
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route> */}
                        <Route path='marketplace/*' element={
                            <PlayerMarketLanding 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                                gameStats={gameStats}
                                teamMembers={teamMembers}
                                myTeams={myTeams}
                            />
                        }></Route>
                        <Route path='challenges/*' element={
                            <PlayerChallenges 
                                gameData={gameData} 
                                gameStats={gameStats}
                                playerData={playerData} 
                                gameElements={gameElements} 
                                actionItems={actionItems} 
                                myTeams={myTeams}
                                teamMembers={teamMembers}
                            />
                        }></Route>
                        <Route path='quests/*' element={
                            <PlayerQuests 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                                myTeams={myTeams}
                            />
                        }></Route>
                        
                        <Route path='leaderboards/*' element={
                            <PlayerLeaderboardsContainer 
                                gameData={gameData} 
                                gameElements={gameElements}
                                playerData={playerData}
                                playerList={playerList} />
                        }></Route>
                        <Route path='gameactivity/*' element={
                            <PlayerActivity 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} />
                        }></Route>
                        <Route path='xp/*' element={
                            <MyXpEarningsList 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route>
                        <Route path='badges' element={
                            <MyBadges 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route>
                        <Route path='badges/:elementPath/*' element={
                            <ElementView 
                                gameData={gameData}
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route>
                        <Route path='levels' element={
                            <MyLevelsList 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route>
                        <Route path='levels/:elementPath/*' element={
                            <ElementView 
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route>
                        <Route path='currency/*' element={
                            <MyCurrencyEarningsList
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements}
                            />
                        }></Route>
                        <Route path='currencytotal' element={
                            <MyCurrencyEarningsList
                                gameData={gameData}     
                                playerData={playerData} 
                                gameElements={gameElements} 
                                total={true} 
                            />
                        }></Route>
                        <Route path='secretcodes' element={
                            <MySecretCodesList
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route>
                        <Route path='secretcodes/:elementId/*' element={
                            <ElementView
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} />
                        }></Route>
                        <Route path='completedchallenges' element={
                            <MyChallengesList
                                gameData={gameData} 
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route>
                        <Route path='transaction/:transPath' element={
                            <div className='purchase-details-container'>
                                <div className='purchase-details g-card'>
                                    <TransactionView
                                        gameData={gameData}
                                        gameElements={gameElements}
                                        playerList={playerList}
                                        gameActivity={gameActivity}
                                    />
                                </div>
                            </div>
                        }></Route>
                        <Route path='*' element={<Navigate replace to="/404" />}></Route>
                    </Routes>
                </div>
                </>
            }
            <NewRewardModal 
                gameData={gameData} 
                gameElements={gameElements} 
                playerData={playerData} 
            />
            <DeclinedChallengeModal 
                gameData={gameData} 
                playerData={playerData} 
                gameElements={gameElements}
            />
            {/* <AcceptedItemModal gameData={gameData} playerData={playerData} playerActivity={playerActivity} gameElements={gameElements}/> */}
            {
                (screenSize === 'mobile' ||
                screenSize === 'tablet') &&
                <div className='mobile-bottom-spacer'></div>
            }
        </div>
    )
}

export default PlayerGameContent